export default {
  url: process.env.VUE_APP_SSO_URL,
  realm: process.env.VUE_APP_SSO_REALM,
  clientId: process.env.VUE_APP_SSO_CLIENT_ID,
  onLoad: process.env.VUE_APP_SSO_ON_LOAD
};
